import { render } from "./ExportUSDZ.vue?vue&type=template&id=206058b5&scoped=true"
import script from "./ExportUSDZ.vue?vue&type=script&lang=js"
export * from "./ExportUSDZ.vue?vue&type=script&lang=js"

import "./ExportUSDZ.vue?vue&type=style&index=0&id=206058b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206058b5"]])

export default __exports__